import { UseMutationOptions, useMutation } from "@tanstack/react-query";
import { FieldValues } from "react-hook-form";
import axiosAuth from "../axiosAuth";
import { CONTRACT_STATE_TEMPLATE_API } from "./apiRoutes";

interface mutateProps {
  data: FieldValues;
  stateTemplateId: string;
}

const mutateUpdateStateLaw = async ({ data, stateTemplateId }: mutateProps) => {
  return await axiosAuth.put(`${CONTRACT_STATE_TEMPLATE_API}/${stateTemplateId}/content`, data);
};

const useUpdateStateLawMutation = (
  queryParams?: UseMutationOptions<any, Error, mutateProps, unknown>
) =>
  useMutation({
    mutationFn: mutateUpdateStateLaw,
    ...queryParams,
  });

export default useUpdateStateLawMutation;
